const formatSchemaWithDefaultValues = (
  stringifiedSchema = '',
  stringifiedData = '',
  dynamicPath = '' // 1. Added dynamicPath argument
) => {
  if (!stringifiedSchema) return [];
  if (!stringifiedData) return JSON.parse(stringifiedSchema);

  const uiSchema = JSON.parse(stringifiedSchema);
  let storedData = JSON.parse(stringifiedData);

  const findValueIgnoreCase = (obj, targetKey) => {
    if (!obj || typeof obj !== 'object') return undefined;
    const lowerTarget = targetKey.toLowerCase();
    const matchingKey = Object.keys(obj).find(
      (k) => k.toLowerCase() === lowerTarget
    );
    return matchingKey ? obj[matchingKey] : undefined;
  };

  // 2. Drill down into storedData using the dynamicPath to find nested parameters
  if (dynamicPath && storedData) {
    const pathParts = dynamicPath.split('.');
    let nestedData = storedData;

    for (const part of pathParts) {
      if (nestedData && typeof nestedData === 'object') {
        const matchingKey = Object.keys(nestedData).find(
          (k) => k.toLowerCase() === part.toLowerCase()
        );
        nestedData = matchingKey ? nestedData[matchingKey] : undefined;
      } else {
        nestedData = undefined;
        break;
      }
    }

    // If we successfully found nested data for this specific path, use it.
    if (nestedData !== undefined) {
      storedData = nestedData;
    }
  }

  const mapSchema = (schema, parameters) => {
    return schema.map((field) => {
      const updatedField = { ...field };
      const savedValue = findValueIgnoreCase(parameters, field.key);

      if (field.type === 'object' && Array.isArray(field.itemSchema)) {
        updatedField.itemSchema = mapSchema(field.itemSchema, savedValue || {});
      } else if (
        (field.type === 'array' || field.type === 'staticArray') &&
        Array.isArray(field.itemSchema) &&
        Array.isArray(savedValue)
      ) {
        updatedField.defaultValue = savedValue.map((row) => {
          if (!row || typeof row !== 'object') return row;

          const normalizedRow = { ...row };

          field.itemSchema.forEach((subField) => {
            const val = findValueIgnoreCase(row, subField.key);
            if (val !== undefined) {
              normalizedRow[subField.key] = val;
            }
          });

          return normalizedRow;
        });
      } else {
        if (savedValue !== undefined) {
          updatedField.defaultValue = savedValue;
        }
      }

      return updatedField;
    });
  };

  return mapSchema(uiSchema, storedData);
};

export default formatSchemaWithDefaultValues;
